import fetch from "../fetch";
import pickBy from "lodash/pickBy";

export default ({ params = {} } = {}) =>
  fetch({ path: "/cmbs/deal-types", params: pickBy(params) });
